var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.61111 3.14713e-05C4.68121 3.14713e-05 3.11111 1.57013 3.11111 3.50003C3.11111 5.42993 4.68121 7.00003 6.61111 7.00003C8.54101 7.00003 10.1111 5.42993 10.1111 3.50003C10.1111 1.57013 8.54101 3.14713e-05 6.61111 3.14713e-05Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2256 10.3661C11.0757 9.19856 9.55139 8.55559 7.93333 8.55559H6.06667C4.44864 8.55559 2.92426 9.19856 1.77439 10.3661C0.630156 11.5279 0 13.0615 0 14.6845C0 14.9422 0.208942 15.1511 0.466667 15.1511H13.5333C13.7911 15.1511 14 14.9422 14 14.6845C14 13.0615 13.3698 11.5279 12.2256 10.3661Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeLogo);
export default __webpack_public_path__ + "static/media/Me_logo.522170f429555515f5ba3ca496485115.svg";
export { ForwardRef as ReactComponent };